import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Grid,
  DialogActions,
  Button,
  Tooltip,
} from "@material-ui/core";
import {
  AddPhotoAlternateOutlined,
  Close,
  DeleteOutline,
  Photo,
} from "@mui/icons-material";
import DocumentPreview from "components/_refactor/document-preview";
import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function DialogGalery({
  onClose,
  images,
  AddImage,
  RemoveImage,
  MAX_IMAGES,
}) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const selectedImage = images[selectedImageIndex];

  return (
    <Dialog open onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Photo />
            Galeria de Imagens
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {selectedImage && (
              <DocumentPreview
                url={selectedImage.base64 || selectedImage.ImagemUrl}
              />
            )}
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              flexDirection: "row",
              gap: "1rem",
              justifyContent: "center",
              marginBottom: "1rem",
            }}
          >
            {images.length > 1 &&
              images.map((image, index) => (
                <div style={{ position: "relative" }} key={index}>
                  <Tooltip title="Remover imagem" hidden={!RemoveImage}>
                    <IconButton
                      onClick={() => RemoveImage(index)}
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        transform: "translate(50%, -50%)",
                        zIndex: 1000,
                        backgroundColor: themeColorsDesingSystem.white.main,
                      }}
                      size="small"
                      color="primary"
                    >
                      <DeleteOutline fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Box
                    onClick={() => setSelectedImageIndex(index)}
                    style={{
                      width: "5vw",
                      height: "5vw",
                      cursor: "pointer",
                      border:
                        selectedImageIndex === index
                          ? "2px solid " + themeColorsDesingSystem.primary.main
                          : "1px solid #e0e0e0",
                      borderRadius: "4px",
                      overflow: "hidden",
                      backgroundColor: "#fff",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (selectedImageIndex !== index) {
                        e.currentTarget.style.opacity = "1";
                        e.currentTarget.style.transform = "scale(1.05)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectedImageIndex !== index) {
                        e.currentTarget.style.opacity = "0.7";
                        e.currentTarget.style.transform = "scale(1)";
                      }
                    }}
                  >
                    <img
                      src={image.base64 || image.ImagemUrl}
                      alt={
                        image.name ||
                        image.NomeArquivo ||
                        `Thumbnail ${index + 1}`
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                </div>
              ))}
            <IconButton
              onClick={AddImage}
              hidden={!AddImage || images.length >= MAX_IMAGES}
            >
              <AddPhotoAlternateOutlined fontSize="medium" />
            </IconButton>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
